import React from 'react';

interface IconKeywordProps {
  className?: string;
  size?: number;
  color?: string;
}

export const IconKeyword: React.FC<IconKeywordProps> = ({ className = '', size = 16, color = 'currentColor' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_8810_4258)">
        <path
          d="M7.99983 0.800781C9.35561 0.800784 10.6838 1.18359 11.8317 1.90514C12.9795 2.62668 13.9003 3.65765 14.488 4.8794C15.0758 6.10115 15.3067 7.46403 15.1541 8.81119C15.0015 10.1584 14.4716 11.4351 13.6254 12.4944L14.731 13.6008C14.8768 13.7517 14.9574 13.9537 14.9556 14.1635C14.9537 14.3733 14.8696 14.5739 14.7213 14.7222C14.573 14.8706 14.3723 14.9547 14.1625 14.9565C13.9528 14.9583 13.7507 14.8777 13.5998 14.732L12.4934 13.6264C11.5948 14.3442 10.5373 14.8363 9.40939 15.0615C8.28151 15.2866 7.1161 15.2383 6.01073 14.9206C4.90536 14.6028 3.89218 14.0249 3.05603 13.2352C2.21988 12.4455 1.58509 11.4669 1.20479 10.3815C0.824496 9.29605 0.709764 8.1353 0.870202 6.99641C1.03064 5.85752 1.46158 4.77364 2.12694 3.83551C2.79231 2.89737 3.67273 2.13228 4.69451 1.60429C5.71629 1.0763 6.84969 0.800778 7.99983 0.800781ZM7.99983 2.40078C7.26442 2.40078 6.53622 2.54563 5.8568 2.82706C5.17738 3.10848 4.56004 3.52098 4.04003 4.04098C3.52002 4.56099 3.10753 5.17833 2.8261 5.85775C2.54467 6.53718 2.39983 7.26538 2.39983 8.00078C2.39983 8.73618 2.54467 9.46439 2.8261 10.1438C3.10753 10.8232 3.52002 11.4406 4.04003 11.9606C4.56004 12.4806 5.17738 12.8931 5.8568 13.1745C6.53622 13.4559 7.26442 13.6008 7.99983 13.6008C9.48504 13.6008 10.9094 13.0108 11.9596 11.9606C13.0098 10.9104 13.5998 9.48599 13.5998 8.00078C13.5998 6.51557 13.0098 5.09119 11.9596 4.04098C10.9094 2.99078 9.48504 2.40078 7.99983 2.40078ZM9.99983 5.34078C10.212 5.34078 10.4155 5.42507 10.5655 5.5751C10.7155 5.72512 10.7998 5.92861 10.7998 6.14078C10.7998 6.35295 10.7155 6.55644 10.5655 6.70647C10.4155 6.8565 10.212 6.94078 9.99983 6.94078H8.79983V10.5408C8.8 10.7369 8.72815 10.9262 8.59792 11.0728C8.46769 11.2194 8.28816 11.313 8.09343 11.336L7.99983 11.3408C7.78765 11.3408 7.58417 11.2565 7.43414 11.1065C7.28411 10.9564 7.19983 10.753 7.19983 10.5408V6.94078H5.99983C5.80388 6.94076 5.61476 6.86882 5.46833 6.73861C5.3219 6.6084 5.22835 6.42898 5.20543 6.23438L5.19983 6.14078C5.19983 5.92861 5.28411 5.72512 5.43414 5.5751C5.58417 5.42507 5.78765 5.34078 5.99983 5.34078H9.99983Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_8810_4258">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconKeyword;
